import UrlHashWatcher from '@/helpers/UrlHashWatcher'

const urlWatcher = new UrlHashWatcher()

export default urlWatcher